import React from "react"
import Layout from "../components/global/Layout"
import SEO from '../components/global/SEO'

import StyledHero from "../components/StyledHero"
import { graphql } from "gatsby"
import VacationDeals from "../components/home/vacation-deals"

import PeopleLoveOurOffers from "../components/home/PeopleLove"
import ResortDeals from "../components/global/footer/ResortDeals"

import BlueBar from "../components/home/BlueBar"

import MailingList from "../components/global/MailingList"
import LocationDeals from "../components/deals-by-location/location-deals"
import SeeWhyOur from '../components/home/SeeWhyOur'
import Testimonials from '../components/global/Testimonials'


const index = ({ data }) => {
  return (
    <Layout>
      <SEO
        title={data.page.metaTitle}
        description={data.page.metaDescription}
      />
      <StyledHero home 
        img={data.page.bannerImage ? data.page.bannerImage.fluid : "" }>
        <VacationDeals />
      </StyledHero>
      <BlueBar 
         title={data.page.underBannerText}
         images={data.page.images} 
      />
      
      
      <LocationDeals destinations={data.destinations.edges}/>
      
      <PeopleLoveOurOffers 
        miscText = {data.page.miscText}
        miscText2 = {data.page.miscText2}
        images={data.page.images}/>
      {/* <OurTopMexican /> */}
      
      {/* <Resorts /> */}
      <SeeWhyOur />
      {/* <CarouselTestimonials
        testimonials={data.testimonials.edges}
        image={data.page.images[1]}
      /> */}
      <Testimonials />
      <MailingList />
      
      <ResortDeals resort1={data.resort1} resort2={data.resort2}/>
    </Layout>
  )
}

export const query = graphql`
query ($locale: String)
  {
    page: contentfulPagesWithBanner(
      slug: { eq: "/" },
      node_locale: { eq: $locale } 
    ) {
      id
      node_locale
      title
      metaTitle
      metaDescription
      miscText {
        miscText
      }
      miscText2 {
        miscText2
      }
      
      bannerInfo
      underBannerText
      bannerImage {
        fluid (quality: 80 maxWidth: 1800){
          #srcSet
          ...GatsbyContentfulFluid_withWebp
        }
      }
      images {
        fluid (quality: 80, maxWidth: 1800){
          #srcSet
          ...GatsbyContentfulFluid_withWebp
        }
      }
    }

    testimonials: allContentfulTestimonials(
      filter: { isInHome: { eq: true } }
    ) {
      edges {
        node {
          poster
          testimonial {
            testimonial
          }
          color1
          color2
          id
        }
      }
    }

    destinations: allContentfulDestinations(
      filter: { node_locale: {eq: $locale} }
      sort: {order: ASC, fields: order}
      ) {
      edges {
        node {
          id
          slug
          title
          subTitle
          fromPrice
          promotionalPrice
          savingPercent
          node_locale
          mainImage {
            title
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
    }

    ##  Resorts para el footer
    resort1: contentfulResorts(
      slug: { eq: "el-cid-marina" },
      node_locale: { eq: $locale}
      ) {
      slug
      footerTitle
      footerSubTitle
      promoPrice
      footerImage {
        fluid(maxHeight: 400, quality: 80) {
          #src
          ...GatsbyContentfulFluid
        }
      }
    }
    resort2: contentfulResorts(
      slug: { eq: "ventus" },
      node_locale: { eq: $locale}
      ) {
      slug
      footerTitle
      footerSubTitle
      promoPrice
      footerImage {
        fluid(maxHeight: 400, quality: 80) {
          #src
          ...GatsbyContentfulFluid
        }
      }
    }
    ## Terminan Resorts para el Footer

  }
`

export default index